import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css';

import { LicenseManager } from '@ag-grid-enterprise/all-modules';
LicenseManager.setLicenseKey('CompanyName=Greenheck Fan Corp,LicensedGroup=Greenheck Digital Solutions Team,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=3,LicensedProductionInstancesCount=1,AssetReference=AG-013075,ExpiryDate=20_January_2022_[v2]_MTY0MjYzNjgwMDAwMA==c4ef28d0eb8def1558cfc0b85e823f5f');

import * as $ from 'jquery';
import * as ReactDom from 'react-dom';

import { Router } from './components/router';

$(() => {
    const element = document.getElementById('main');
    if (!element)
        throw new Error('Cannot find target rendering element');

    ReactDom.render(Router(), element);
});